import { Text } from '@factorialco/deprecated-design-system'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

export const Date = ({ date }: { date: string }) => {
  return <Text.Normal size="200">{dateBackendDateTimeToUI(date)}</Text.Normal>
}
